import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Login.css';

class ClaimCredits300 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      balance: 0,
      errorMessage: '',
      successMessage: '',
      isLoading: false,
      isClaimed: false,
    };
  }

  componentDidMount() {
    const { state } = this.props.location;
    if (state && state.email && state.balance !== undefined) {
      this.setState({ email: state.email, balance: state.balance });
    } else {
      this.fetchUserData();
    }
  }

  fetchUserData = async () => {
    try {
      const response = await fetch('/user-details', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.ok) {
        const data = await response.json();
        this.setState({ email: data.email, balance: Number(data.balance || 0) });
      } else {
        this.setState({ errorMessage: 'Failed to fetch user details. Please log in again.' });
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
      this.setState({ errorMessage: 'Unable to connect to server.' });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { balance, email, isClaimed } = this.state;

    if (isClaimed) {
      this.setState({ errorMessage: 'You already claimed your 300 credits.' });
      return;
    }

    const newBalance = balance + 300;
    this.setState({ isLoading: true, errorMessage: '', successMessage: '' });

    try {
      const updateResponse = await fetch('/update-balance', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, newBalance }),
      });

      if (!updateResponse.ok) {
        const data = await updateResponse.json().catch(() => ({}));
        throw new Error(data.message || 'Failed to update balance.');
      }

      this.setState({
        successMessage: '🎉 You have claimed your 300 credits successfully!',
        errorMessage: '',
        balance: newBalance,
        isClaimed: true,
      });

      // 🔹 Redirect to homepage after 1.5 seconds
      setTimeout(() => {
        this.handleLogout();
      }, 1500);

    } catch (error) {
      console.error('Error:', error);
      this.setState({
        errorMessage: error.message || 'An unexpected error occurred!',
        successMessage: '',
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleLogout = () => {
    // Redirect to homepage
    this.props.history.push('/');
  };

  render() {
    const { email, balance, errorMessage, successMessage, isLoading, isClaimed } = this.state;

    return (
      <div className="login-container d-flex align-items-center justify-content-center">
        <div className="text-center" style={{ width: '100%', maxWidth: '420px' }}>
          <img className="logo mb-3" src={logo} alt="Logo" />
          <div className="user-details mt-2">
            <strong>Email:</strong> {email || 'Loading...'} &nbsp;|&nbsp;
            <strong>Balance:</strong> ${balance.toFixed(2)}
          </div>
          <div className="card shadow-sm">
            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                <div className="form-group mb-3 text-start">
                  <label htmlFor="amount">Reward Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    id="amount"
                    value={300}
                    readOnly
                  />
                </div>

                {errorMessage && <div className="alert alert-danger py-2">{errorMessage}</div>}
                {successMessage && <div className="alert alert-success py-2">{successMessage}</div>}

                <button
                  type="submit"
                  className="btn btn-dark w-100"
                  disabled={isLoading || isClaimed}
                >
                  {isLoading
                    ? 'Claiming...'
                    : isClaimed
                    ? 'Already Claimed'
                    : 'Claim 300 Credits'}
                </button>
              </form>

              <button
                onClick={this.handleLogout}
                className="btn btn-outline-secondary w-100 mt-3"
              >
                Logout
              </button>

              <div className="mt-4 text-center small text-muted">
                <p>Powered by</p>
                <img src={logo2} alt="Logo 2" style={{ width: '80px', opacity: 0.85 }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ClaimCredits300);
